/* DENSA — İçerik Coğraf yası karuseli v10.2 — 11 Ağu 2026
   v10.2 (kapak kartlı karusel desteği — coğrafya v2.0): İKİ KÜÇÜK, GERİYE UYUMLU EK.
     ① Şeritte `data-sarmasiz` niteliği varsa sonsuz sarma (klonlama+teleport) O BÖLÜMDE kapalı —
        uçlarda durur. Nitelik olmayan bölümlerde davranış AYNEN v10.1 (klonlu sonsuz döngü).
        Gerekçe: kapak kartı şeridin ilk öğesi; klonlanması kapağı uçlarda belirtirdi.
     ② git(i) hedef indeksi 0..son aralığına kırpıyor — sarmasız bölümde uçtaki ok/jest NaN
        üretemez. Sarmalı bölümlerde çağrılar zaten aralık içinde; davranış değişmez.
   v10.1 (görsel diyeti — iOS bellek): klonlar tam set yerine uç başına en çok 3 kart; arka plan N katmanlı sınıf modelinden İKİ katmanlı çapraz soldurmaya indi (URL aktif kartın data-arka'sından background-image olarak basılır); kurulumdan sonra tüm kart görselleri (720w) ve arka planlar (1080w) new Image() ile ısındırılır. Jest-adım modeli, sonsuz sarma, teleport garantileri, çubuk ve aktif büyüme AYNEN.
   v10: mobil jest-adım modeli — kurucu kararı: her kaydırma tam bir kart.
   v9 (kurucu, ikinci bildirim: mobilde kart ortaya oturmuyor + hızlı inişte sayfa kendini yeniledi):
     A) SNAP KAPALI KALAMAZ — teleport (isinla) try/finally garantisinde: istisna olsa bile
        scroll-snap-type ve scroll-behavior AYNI KAREDE CSS'e döner; bir sonraki karede rAF ile
        ikinci kez doğrulanır. Fare sürüklemesinin .tutuluyor sınıfı (CSS'te snap'i kapatıyor)
        pointerup + pointercancel + pencere blur'unda temizlenir — sınıf asılı kalıp snap'i
        öldüremez. Dürüst not: v8'de geri açma tek yoldu ve korumasızdı; araya giren bir istisna
        ya da asılı kalan .tutuluyor, snap'i kalıcı kapatıp kurucunun tarif ettiği "serbest
        kaydırma" tablosunu (kart ortaya oturmuyor) yaratıyordu.
     B) DOKUNMA/MOMENTUM KİLİDİ — teleport parmak ekrandayken ve fare basılıyken çalışmaz
        (touchstart→touchend/touchcancel kilidi); rAF yolunda ayrıca 120ms kaydırma sessizliği
        şartı var. Resize kaynaklı git() çağrıları da kilitliyken atlanır.
     C) TEMBEL + SAVUNMACI KURULUM — klonlama ve dinleyiciler bölüm görünüme yaklaşınca kurulur
        (IntersectionObserver, 600px marj); kurulum, rAF döngüsü ve tüm geri çağrılar try/catch
        içinde. Hata olursa karusel sessizce DÜZ ŞERİT kalır — sayfa ASLA çökmez (hızlı iniş
        çökmesinin panzehiri). Dinleyiciler ancak ilk konumlama bitince bağlanır.
     D) rAF izleyici bölüm viewport dışında ya da sekme gizliyken durur (IO + visibilitychange).
        Scroll/resize dinleyicilerinde döngüsel tetikleme yok: boya() yalnız ölçü önbelleğinden
        okur; yazdığı class/çizgi stilleri kaydırma doğurmaz. ResizeObserver kullanılmaz.
     E) ÖLÇÜM GÖRSELE MUHTAÇ DEĞİL — kart genişlikleri CSS'te sabit (clamp/78vw), editoryal görsel
        aspect-ratio 4/5; yine de her görsel yüklendiğinde ve resize/orientationchange sonrası
        ölçü önbelleği yeniden hesaplanır (klon ölçüleri dahil — hepsi tek önbellekte).
     Korunanlar: KLONLU sonsuz döngü (kurucu kararı), çubuk %0'dan başlar, ilk gerçek kart
     merkezde açılır, arka plan katmanı aktif kartı izler, otomatik dönme YOK (K61).
   v8: teleport yalnız tam duruşta + ölçü önbelleği. v7: klon-orijinal-klon. v5: nativ scroll-snap. */
(function () {
  if (window.__densaDcg10) return;
  window.__densaDcg10 = true;

  function kur(kok) {
    var serit = kok.querySelector('.dcg-serit');
    if (!serit) return;
    var asil = Array.prototype.slice.call(serit.querySelectorAll('.dcg-kart'));
    var N = asil.length;
    if (!N) return;
    var katmanlar = Array.prototype.slice.call(kok.querySelectorAll('.dcg-arka .katman'));
    var cizgi = kok.querySelector('.dcg-cizgi span');
    var sonBoyanan = -1;

    /* v10.1 — İKİ katmanlı arka plan: URL'ler gerçek kartların data-arka'sından; aktif kart
       değişince arkadaki katmana yeni görsel basılır ve opacity geçişiyle çapraz soldurulur.
       Bellek: N tam ekran görsel yerine en fazla 2 çözülmüş görsel. */
    var arkaUrl = asil.map(function (k) { return k.getAttribute('data-arka') || ''; });
    var onKat = -1, sonArka = '';
    function arkaGecis(r) {
      if (katmanlar.length < 2) return;
      var url = arkaUrl[r];
      if (!url || url === sonArka) return;
      var gelenIdx = onKat === 0 ? 1 : 0;
      var gelen = katmanlar[gelenIdx];
      gelen.style.backgroundImage = 'url("' + url + '")';
      gelen.classList.add('aktif');
      if (onKat >= 0) katmanlar[onKat].classList.remove('aktif');
      onKat = gelenIdx; sonArka = url;
    }

    var donguluMu = N > 2 && !serit.hasAttribute('data-sarmasiz'); /* v10.2: kapaklı bölüm sarmayı kapatabilir */
    var KLON = donguluMu ? Math.min(N, 3) : 0; /* v10.1: uçlardaki görünür alanı dolduracak kadar klon yeter — DOM'da 3N değil N+2·KLON görsel */
    if (donguluMu) {
      var onc = document.createDocumentFragment();
      var son = document.createDocumentFragment();
      for (var ci = 0; ci < KLON; ci++) {
        var a = asil[N - KLON + ci].cloneNode(true); a.setAttribute('data-klon', ''); onc.appendChild(a);
        var b = asil[ci].cloneNode(true); b.setAttribute('data-klon', ''); son.appendChild(b);
      }
      serit.insertBefore(onc, serit.firstChild);
      serit.appendChild(son);
    }
    var hepsi = Array.prototype.slice.call(serit.querySelectorAll('.dcg-kart'));
    var ofset = donguluMu ? KLON : 0;
    var baslangic = ofset;   /* ilk gerçek kart merkezde — solunda son kartın klonu durur */

    /* ── ölçü önbelleği: kaydırma sırasında layout okuması YOK ── */
    var merkezler = [], SW = 0, seritW = 0;
    function olc() {
      seritW = serit.clientWidth;
      merkezler = hepsi.map(function (k) { return k.offsetLeft + k.offsetWidth / 2; });
      SW = donguluMu ? (hepsi[ofset + N].offsetLeft - hepsi[ofset].offsetLeft) : 0;
    }
    function hedefSol(i) { return merkezler[i] - seritW / 2; }
    function aktifIndeks() {
      if (!merkezler.length) return 0;
      var merkez = serit.scrollLeft + seritW / 2;
      var en = 0, mes = Infinity;
      for (var i = 0; i < merkezler.length; i++) {
        var d = Math.abs(merkezler[i] - merkez);
        if (d < mes) { mes = d; en = i; }
      }
      return en;
    }
    function gercek(i) { return ((i - ofset) % N + N) % N; }

    /* ── jest/momentum durumu ── */
    var parmakta = false, basili = false, tasindi = false, sx = 0, ss = 0;
    var calisiyor = false, gorunurde = false, sonDeger = -1, sonHareket = 0, sonHareketMs = 0;
    var etkilesim = false;
    /* v10 jest-adım durumu: hedef = animasyonun gittiği indeks; hedefBekliyor açıkken
       senkron ölçümden değil indeksten sürülür (boya susar, boyaR konuşur) */
    var hedef = baslangic, hedefBekliyor = false, jestBozuk = false;
    function kilitli() { return parmakta || basili || (performance.now() - sonHareketMs < 120); }

    function git(i) {
      if (i < 0) i = 0; else if (i > hepsi.length - 1) i = hepsi.length - 1; /* v10.2: uçlarda kırp — sarmasız bölüm NaN üretemez */
      try { serit.scrollTo({ left: hedefSol(i), behavior: 'smooth' }); }
      catch (h) { serit.scrollLeft = hedefSol(i); }
    }

    function boyaR(r, zorla) {
      if (!zorla && r === sonBoyanan) return;
      sonBoyanan = r;
      hepsi.forEach(function (k, i) { k.classList.toggle('aktif', gercek(i) === r); });
      try { arkaGecis(r); } catch (h) {}
      if (cizgi) {
        var w = 100 / N;
        cizgi.style.width = w + '%';
        cizgi.style.left = (r * w) + '%';
      }
    }
    function boya(zorla) {
      if (hedefBekliyor && !zorla) return; /* v10: adım animasyonu sürerken senkron indeksten sürülür */
      boyaR(gercek(aktifIndeks()), zorla);
    }

    /* ── sonsuz sarma (teleport): parmak/fare varken ASLA; snap HER DURUMDA aynı karede geri ── */
    function isinla() {
      if (!donguluMu || !SW || parmakta || basili) return;
      var yeni;
      try {
        var alt = hedefSol(ofset), ust = alt + SW;
        var s = serit.scrollLeft; yeni = s; var emniyet = 0;
        while (yeni < alt - 2 && emniyet < 8) { yeni += SW; emniyet++; }
        while (yeni > ust - 2 && emniyet < 8) { yeni -= SW; emniyet++; }
        if (!isFinite(yeni) || Math.abs(yeni - s) < 1) return;
      } catch (h) { return; } /* hesap tutmadıysa hiç dokunma — snap'e el sürülmedi */
      try {
        serit.style.scrollBehavior = 'auto';
        serit.style.scrollSnapType = 'none';
        serit.scrollLeft = yeni;
        void serit.offsetWidth; /* aynı karede uygulat */
      } finally {
        /* GARANTİ: istisna olsa bile snap AYNI KAREDE geri açılır… */
        serit.style.scrollSnapType = '';
        serit.style.scrollBehavior = '';
        requestAnimationFrame(function () {
          /* …ve bir sonraki karede çift emniyetle doğrulanır. */
          if (serit.style.scrollSnapType) serit.style.scrollSnapType = '';
          if (serit.style.scrollBehavior) serit.style.scrollBehavior = '';
        });
      }
      sonDeger = serit.scrollLeft;
      hedef = aktifIndeks(); /* v10: teleport sonrası hedef tazelenir */
      boya();
    }

    /* rAF izleyici: yalnız bölüm görünürde VE sekme öndeyken; hata olursa susar, şerit düz kalır */
    function dongu(ts) {
      if (!calisiyor) return;
      try {
        var s = serit.scrollLeft;
        if (s !== sonDeger) {
          sonDeger = s; sonHareket = ts; sonHareketMs = performance.now();
          boya();
        } else if (ts - sonHareket > 120) {
          hedefBekliyor = false; /* v10: adım animasyonu bitti — senkron ölçüme döner */
          isinla();
        }
      } catch (h) { calisiyor = false; return; }
      requestAnimationFrame(dongu);
    }
    function izleyiciAyarla() {
      var olmali = gorunurde && !document.hidden;
      if (olmali && !calisiyor) {
        calisiyor = true;
        sonHareket = performance.now(); sonHareketMs = sonHareket;
        requestAnimationFrame(dongu);
      } else if (!olmali) { calisiyor = false; }
    }

    function surukleBirak() {
      if (!basili) return;
      basili = false;
      serit.classList.remove('tutuluyor'); /* asılı kalırsa CSS snap'i kapalı bırakırdı */
      if (tasindi) { try { git(aktifIndeks()); } catch (h) {} setTimeout(function () { tasindi = false; }, 60); }
    }

    function baslat(ilk) {
      olc();
      if (ilk || !etkilesim) { /* kullanıcı dokunduysa konumuna karışma */
        try { serit.scrollTo({ left: hedefSol(baslangic), behavior: 'auto' }); }
        catch (h) { serit.scrollLeft = hedefSol(baslangic); }
        sonDeger = serit.scrollLeft;
      }
      boya(true);
    }
    function tazele(gitsin) {
      try {
        olc();
        if (gitsin && !kilitli()) git(aktifIndeks());
        boya(true);
      } catch (h) {}
    }

    /* ── kurulum: ÖNCE konumlan, dinleyiciler ancak bundan sonra bağlanır ── */
    baslat(true);

    /* v10.1 ISINDIRMA: kart görselleri (720w) ve arka planlar (1080w) kurulumdan hemen sonra
       arka planda önden indirilir — ilk geçişte bile içerik hazır (lazy kartların telafisi). */
    setTimeout(function () {
      try {
        asil.forEach(function (k) {
          var g = k.querySelector('.dcg-medya img') || k.querySelector('img');
          if (g) { var s = g.currentSrc || g.getAttribute('src'); if (s) { (new Image()).src = s; } }
          var u = k.getAttribute('data-arka'); if (u && u !== sonArka) { (new Image()).src = u; }
        });
      } catch (h) {}
    }, 250);

    serit.addEventListener('touchstart', function () { parmakta = true; etkilesim = true; }, { passive: true });
    serit.addEventListener('touchend', function () { parmakta = false; }, { passive: true });
    serit.addEventListener('touchcancel', function () { parmakta = false; }, { passive: true });

    /* ── v10 MOBİL JEST-ADIM: dokunmatikte serbest kaydırma yok; her jest tam bir kart ──
       Eksen kilidi: |dx|>|dy| anında yatay kilitlenir, preventDefault (CSS'te .jest sınıfına
       touch-action: pan-y eşlik eder). Parmak kalkınca |dx| >= 25px → yöne göre TEK adım,
       mevcut smooth merkezleme ile (kart daima tam merkezde). |dx| < 25px = dokunuş.
       Animasyon sürerken gelen jest kuyruklanmaz, hedefi bir sonrakine yönlendirir.
       Herhangi bir hata modeli kapatır (.jest kalkar) → v9 native scroll+snap geri gelir. */
    var dokunmatik = false;
    try {
      dokunmatik = ('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    } catch (h) {}
    if (dokunmatik) {
      try {
        serit.classList.add('jest');
        var jX = 0, jY = 0, jEksen = '';
        var jestKapat = function () {
          jestBozuk = true; hedefBekliyor = false;
          try { serit.classList.remove('jest'); } catch (h) {}
        };
        serit.addEventListener('touchstart', function (e) {
          if (jestBozuk) return;
          try {
            if (e.touches.length !== 1) { jEksen = 'iptal'; return; }
            jX = e.touches[0].clientX; jY = e.touches[0].clientY; jEksen = '';
          } catch (h) { jestKapat(); }
        }, { passive: true });
        serit.addEventListener('touchmove', function (e) {
          if (jestBozuk || jEksen === 'iptal') return;
          try {
            var t = e.touches[0];
            if (!t) return;
            var dx = t.clientX - jX, dy = t.clientY - jY;
            if (!jEksen) {
              if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 4) jEksen = 'x';
              else if (Math.abs(dy) >= Math.abs(dx) && Math.abs(dy) > 4) jEksen = 'y'; /* dikey ağırlık: sayfaya bırak */
            }
            if (jEksen === 'x' && e.cancelable) e.preventDefault(); /* şerit kaymaz — adım touchend'de atılır */
          } catch (h) { jestKapat(); }
        }, { passive: false });
        serit.addEventListener('touchend', function (e) {
          if (jestBozuk) return;
          try {
            if (jEksen !== 'x') { jEksen = ''; return; }
            var t = e.changedTouches && e.changedTouches[0];
            var dx = t ? (t.clientX - jX) : 0;
            jEksen = '';
            if (Math.abs(dx) < 25) return; /* dokunuş sayılır — adım yok */
            etkilesim = true;
            var yon = dx < 0 ? 1 : -1; /* az da çekilse çok da çekilse TAM BİR kart — kurucu kararı */
            var taban = hedefBekliyor ? hedef : aktifIndeks(); /* animasyondaki jest: mevcut hedefin bir sonrakine */
            var yeni = taban + yon;
            if (yeni < 0) yeni = 0;
            if (yeni > hepsi.length - 1) yeni = hepsi.length - 1;
            hedef = yeni; hedefBekliyor = true;
            boyaR(gercek(hedef)); /* senkron indeksten: arka plan + çubuk + büyüme anında doğru */
            git(hedef);
          } catch (h) { jestKapat(); }
        }, { passive: true });
        serit.addEventListener('touchcancel', function () { jEksen = ''; }, { passive: true });
      } catch (h) {
        jestBozuk = true; hedefBekliyor = false;
        try { serit.classList.remove('jest'); } catch (h2) {}
      }
    }

    if ('onscrollend' in window) {
      serit.addEventListener('scrollend', function () { hedefBekliyor = false; try { isinla(); } catch (h) {} });
    }
    serit.addEventListener('scroll', function () {
      sonHareketMs = performance.now();
      try { boya(); } catch (h) {}
    }, { passive: true });

    Array.prototype.forEach.call(kok.querySelectorAll('.dcg-ok'), function (ok) {
      ok.addEventListener('click', function () {
        etkilesim = true;
        try { git(aktifIndeks() + (ok.classList.contains('sag') ? 1 : -1)); } catch (h) {}
      });
    });

    hepsi.forEach(function (k, i) {
      k.addEventListener('click', function (e) {
        if (tasindi) { e.preventDefault(); return; }
        etkilesim = true;
        if (i !== aktifIndeks()) { e.preventDefault(); try { git(i); } catch (h) {} }
      });
    });

    serit.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      basili = true; tasindi = false; etkilesim = true; sx = e.clientX; ss = serit.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!basili) return;
      var f = e.clientX - sx;
      if (Math.abs(f) > 6 && !tasindi) { tasindi = true; serit.classList.add('tutuluyor'); }
      if (tasindi) { serit.scrollLeft = ss - f; e.preventDefault(); }
    }, { passive: false });
    window.addEventListener('pointerup', surukleBirak);
    window.addEventListener('pointercancel', surukleBirak);
    window.addEventListener('blur', surukleBirak);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (g) {
        gorunurde = g[g.length - 1].isIntersecting;
        izleyiciAyarla();
      }, { rootMargin: '200px' }).observe(kok);
    } else { gorunurde = true; izleyiciAyarla(); }
    document.addEventListener('visibilitychange', izleyiciAyarla);

    window.addEventListener('load', function () { try { baslat(false); } catch (h) {} });
    setTimeout(function () { try { baslat(false); } catch (h) {} }, 600);

    /* görseller (klonlar dahil) geldikçe ölçü önbelleğini tazele — decode beklemeye gerek yok,
       genişlikler CSS'te sabit; bu yalnız emniyet payı */
    Array.prototype.forEach.call(serit.querySelectorAll('img'), function (g) {
      if (!g.complete) g.addEventListener('load', function () { tazele(false); }, { once: true });
    });

    var sonGen = window.innerWidth;
    window.addEventListener('resize', function () {
      var degisti = window.innerWidth !== sonGen;
      sonGen = window.innerWidth;
      tazele(degisti);
    });
    window.addEventListener('orientationchange', function () {
      setTimeout(function () { tazele(true); }, 250); /* yerleşim otursun, sonra yeniden ölç */
    });
  }

  function guvenliKur(kok) {
    try { kur(kok); }
    catch (h) { /* sessiz kal: karusel düz şerit olarak kalır, sayfa ASLA çökmez */ }
  }
  function hepsiniIzle() {
    Array.prototype.forEach.call(document.querySelectorAll('.dcg'), function (kok) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (g) {
          if (g[g.length - 1].isIntersecting) { io.disconnect(); guvenliKur(kok); }
        }, { rootMargin: '600px' });
        io.observe(kok);
      } else { guvenliKur(kok); }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hepsiniIzle);
  } else { hepsiniIzle(); }
})();
